<template>
 <form class="form" :action="apiUrl + '/google/signin'" method="GET">
 <input
    v-for="(v, k) in $route.query"
    :key="k"
    type="hidden"
    :name="k"
    :value="v"
  >
     <button type="submit">LoginGoogle</button>
 </form>
</template>

<script>
export default {
  name: "SignIn",
  setup() {
    const apiUrl = process.env.VUE_APP_IDENTITY_API
    return { apiUrl }
  }
};
</script>